export default "__VITE_ASSET__BvW6uQCm__"